module.exports = __webpack_public_path__ + "img/recommend_content.4dc74f6f.png";